// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"b1f73cf1","520":"4e0e9000"}[chunkId] + ".chunk.css";
};